<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="formUser">
        <base-card>
          <v-card-title>Registrar Usuarios </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  ref="cliente"
                  v-model="dataUser.cliente"
                  :items="detailClients"
                  item-text="NombreCompania"
                  item-value="IdCompania"
                  label="Compañia"
                  prepend-inner-icon="mdi-sitemap"
                  :rules="formRules"
                  :error-messages="errorMessages"
                  filter
                  search-input
                  required
                >
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-text-field
                            class="search-field"
                            v-model="search"
                            placeholder="Buscar"
                            prepend-inner-icon="mdi-magnify"
                            hide-details
                          ></v-text-field>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  ref="name"
                  v-model="dataUser.name"
                  label="Nombre"
                  prepend-inner-icon="mdi-account-tie"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-text-field
                  ref="email"
                  v-model="dataUser.email"
                  label="Correo"
                  prepend-inner-icon="mdi-email"
                  clearable
                  :rules="emailRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field
                  ref="password"
                  v-model="dataUser.password"
                  label="Contraseña"
                  prepend-inner-icon="mdi-account-key"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  ref="rol"
                  v-model="dataUser.rol"
                  :items="typeRol"
                  item-text="textRol"
                  item-value="valueRol"
                  label="Rol"
                  prepend-inner-icon="mdi-account-network"
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  class="ma-2"
                  style="
                    background-color: rgb(204 33 40);
                    color: white !important;
                  "
                  @click="validateUser"
                >
                  Registrar
                </v-btn>
              </v-col>
              <v-alert v-show="successAlert" type="success" text>
                {{ msgSuccessAlert }}
              </v-alert>
            </v-row>
          </v-card-text>
        </base-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { getListRoles } from "@/data/listRoles";

export default {
  name: "RegistrarUsers",

  data() {
    return {
      dataUser: {},
      rol: "",
      email: "",
      password: "",
      cliente: "",
      name: "",
      search: "",
      typeRol: [],
      errorMessages: "",
      formHasErrors: null,
      successAlert: false,
      msgSuccessAlert: "Usuario registrado exitosamente",
      detailsClient: {},
      detailsClients: {},
      formRules: [(v) => !!v || "Este campo es requerido"],
      emailRules: [
        (v) => !!v || "Este campo es requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo inválido",
      ],
    };
  },
  computed: {
    formUser() {
      return {
        // cliente: this.dataUser.cliente,
        rol: this.dataUser.rol,
        name: this.dataUser.name,
        password: this.dataUser.password,
        email: this.dataUser.email,
      };
    },
    detailClients() {
      const estados = {
        D: "Demo",
        P: "Producción",
        H: "Habilitación",
      };

      return (this.$store.state.clients.listClients.Mensaje || [])
        .filter((compania) =>
          compania.NombreCompania.toLowerCase().includes(
            this.search.toLowerCase()
          )
        )
        .map((compania) => {
          const estadoNombre = estados[compania.Estado] || "Desconocido";
          return {
            ...compania,
            NombreCompania: `${compania.NombreCompania} - ${estadoNombre}`,
          };
        })
        .sort((a, b) => {
          if (a.NombreCompania < b.NombreCompania) return -1;
          if (a.NombreCompania > b.NombreCompania) return 1;
          return 0;
        });
    },
    statusResponseUser() {
      return this.$store.state.users.statusResponseUser;
    },
  },
  async created() {
    this.getListClients();
    await this.loadRoles();
  },
  watch: {
    formHasErrors() {
      if (this.formHasErrors === false) {
        this.sendUser();
      }
    },
    statusResponseUser(val) {
      if (val === true) {
        this.generateAlertSuccess();
        this.formHasErrors = true;
        this.$store.dispatch("users/setStatusResponse", false);
      }
    },
  },
  methods: {
    async getListClients() {
      await this.$store.dispatch("clients/getListClients");
    },
    generateAlertSuccess() {
      this.successAlert = true;
      this.$store.dispatch("users/getListUsers");
      this.clearForm();
      this.getListClients();
      setTimeout(() => {
        this.successAlert = false;
      }, 3000);
    },
    clearForm() {
      this.$refs.email.reset();
      this.$refs.password.reset();
      this.$refs.rol.reset();
      this.$refs.name.reset();
    },
    validateUser() {
      this.formHasErrors = false;
      Object.keys(this.formUser).forEach((campo) => {
        if (!this.formUser[campo]) this.formHasErrors = true;
        this.$refs[campo].validate(true);
      });
    },
    sendUser() {
      this.search = "";
      this.$store.dispatch("users/insertUser", {
        ...this.dataUser,
      });
    },
    async loadRoles() {
      try {
        this.typeRol = await getListRoles();
      } catch (error) {
        console.error("❌ Error al cargar roles:", error);
      }
    },
  },
};
</script>

<style scoped>
.search-field {
  border-bottom: 1px solid #f2f4f4;
}
</style>
